import { Orientation, DeviceType, Platform } from 'sofa-reborn-react';
import { SET_DEVICE_TYPE, SET_ORIENTATION, SET_PLATFORM, DeviceStateActions } from './types';

export function setDeviceType(value: DeviceType): DeviceStateActions {
	return {
		type: SET_DEVICE_TYPE,
		value,
	};
}

export function setOrientation(value: Orientation): DeviceStateActions {
	return {
		type: SET_ORIENTATION,
		value,
	};
}

export function setPlatform(value: Platform): DeviceStateActions {
	return {
		type: SET_PLATFORM,
		value,
	};
}
